class WorkerSessionToolView extends MUIView 
{
	WorkerSessionToolView() {
		
	}
}